export default __webpack_public_path__ + "static/media/icon-discord.06c0210d.svg";